import { typeCreatorV2 } from 'redux/utils/common';

//  [REDUCER][TYPE]
export const GET_DASHBOARD_DATA: string = typeCreatorV2(
  'DashboardReducer',
  'GetDashboardData'
);

export const GET_DASHBOARD_SOLD_BY_TYPE: string = typeCreatorV2(
  'DashboardReducer',
  'GetDashboardSoldByType'
);

export const GET_DASHBOARD_SALE: string = typeCreatorV2(
  'DashboardReducer',
  'GetDashboardSale'
);
